import { dynamicAssets } from 'js/constants/Paths';

export const parseGamesData = (data) => {
  const { header: { image = '' } = {} } = data;
  image !== '' && (data.header.image = dynamicAssets(image));

  return { ...data };
};
